export default "__VITE_ASSET__BWsJzDHn__"